"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAuthIdentity = exports.withAuthServerSideProps = void 0;
const router_1 = __importDefault(require("next/router"));
const react_1 = __importStar(require("react"));
const app_1 = __importDefault(require("next/app"));
const token_1 = require("../../helpers/token");
const redirect_1 = require("../../helpers/redirect");
const createAuthConfigProps_1 = require("../../client/createAuthConfigProps");
const AuthIdentityContext_1 = require("../../context/AuthIdentityContext");
const withAuthServerSideProps = (options, callback) => {
    const getServerSideProps = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!options.checkAuthProfile) {
            throw new Error("Please provide method to fetch auth user");
        }
        let results = {};
        const accessTokenKey = (_a = options === null || options === void 0 ? void 0 : options.accessTokenKey) !== null && _a !== void 0 ? _a : "token";
        const hasAuthToken = !!(yield (0, token_1.retrieveAuthTokenFromContext)(ctx, accessTokenKey));
        const authUser = hasAuthToken ? yield options.checkAuthProfile(ctx) : null;
        const config = yield (0, createAuthConfigProps_1.createAuthConfigProps)(ctx, authUser, options, options === null || options === void 0 ? void 0 : options.redirection);
        if (callback) {
            results = yield callback({ authUser, config })(ctx);
        }
        return Object.assign(Object.assign({}, results), { props: Object.assign({ authUser, config: config.config }, ((_b = results === null || results === void 0 ? void 0 : results.props) !== null && _b !== void 0 ? _b : {})) });
    });
    return getServerSideProps;
};
exports.withAuthServerSideProps = withAuthServerSideProps;
const withAuthIdentity = (config) => (PageComponent) => {
    var _a, _b, _c;
    const { ssr, apollo: enableApollo, options } = config;
    const { checkAuthProfile, refreshAccessToken, paths } = options;
    const authStorageKey = (_a = options === null || options === void 0 ? void 0 : options.syncAuthEventKeyName) !== null && _a !== void 0 ? _a : "";
    const accessTokenKey = (_b = options === null || options === void 0 ? void 0 : options.accessTokenKey) !== null && _b !== void 0 ? _b : "token";
    const accessTokenValidityDays = (_c = options === null || options === void 0 ? void 0 : options.accessTokenValidityDays) !== null && _c !== void 0 ? _c : 30;
    if (!checkAuthProfile) {
        throw new Error("checkAuthProfile is not defined");
    }
    const WithAuth = (props) => {
        const { pageProps } = props, restProps = __rest(props, ["pageProps"]);
        const { authUser: inAuthUser, config: inConfig, apolloClient } = pageProps, restPageProps = __rest(pageProps, ["authUser", "config", "apolloClient"]);
        if (enableApollo && !apolloClient) {
            throw new Error(`"apollo" is enabled in options, please make sure "withAuthIdentity" is used with "withApolloClient"`);
        }
        const [authUserState, setAuthUserState] = (0, react_1.useState)(inAuthUser);
        const [authConfigState, setAuthConfigState] = (0, react_1.useState)(inConfig);
        const [redirectionPath, setRedirectionPath] = (0, react_1.useState)();
        const setToken = (token) => {
            (0, token_1.setAuthToken)(token, accessTokenKey, accessTokenValidityDays);
        };
        const clearToken = () => {
            (0, token_1.clearAuthToken)(accessTokenKey);
        };
        const fetchUser = () => __awaiter(void 0, void 0, void 0, function* () {
            const fetchedUser = yield checkAuthProfile();
            setAuthUserState(fetchedUser);
            return fetchedUser;
        });
        const refreshToken = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!refreshAccessToken) {
                console.warn("Refresh access token is not implemented! Please check AuthOptions for more details");
                return;
            }
            const refreshedToken = yield refreshAccessToken();
            setToken(refreshedToken);
        });
        const onHandleAuthConfig = (inAutUser) => __awaiter(void 0, void 0, void 0, function* () {
            const { redirection, config: authConfigProps } = yield (0, createAuthConfigProps_1.createAuthConfigProps)(props === null || props === void 0 ? void 0 : props.router, inAutUser, options);
            setRedirectionPath(redirection);
            setAuthConfigState(authConfigProps);
        });
        const signIn = (token) => {
            if (!token)
                return;
            setToken(token);
            (0, redirect_1.redirect)({}, paths.afterAuthPath);
        };
        const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (enableApollo)
                yield apolloClient.cache.reset();
            clearToken();
            window.localStorage.setItem(authStorageKey, Date.now().toString());
            (0, redirect_1.redirect)({}, (_b = (_a = paths === null || paths === void 0 ? void 0 : paths.beforeAuthPath) !== null && _a !== void 0 ? _a : paths === null || paths === void 0 ? void 0 : paths.signInPath) !== null && _b !== void 0 ? _b : "/");
        });
        const onPageLoad = () => __awaiter(void 0, void 0, void 0, function* () { });
        const onPageLoadEnd = () => __awaiter(void 0, void 0, void 0, function* () {
            if (ssr)
                return;
            const user = yield fetchUser();
            onHandleAuthConfig(user);
        });
        (0, react_1.useEffect)(() => {
            if (ssr)
                return;
            const run = () => __awaiter(void 0, void 0, void 0, function* () {
                yield refreshToken();
                const fetchedUser = yield fetchUser();
                onHandleAuthConfig(fetchedUser);
            });
            run();
        }, []);
        (0, react_1.useEffect)(() => {
            if (!ssr)
                return;
            setAuthUserState(inAuthUser);
            setAuthConfigState(inConfig);
        }, [inAuthUser, inConfig]);
        (0, react_1.useEffect)(() => {
            if (!redirectionPath)
                return;
            (0, redirect_1.redirect)({}, redirectionPath);
        }, [redirectionPath]);
        (0, react_1.useEffect)(() => {
            router_1.default.events.on("routeChangeStart", onPageLoad);
            router_1.default.events.on("routeChangeComplete", onPageLoadEnd);
            return () => {
                router_1.default.events.off("routeChangeStart", onPageLoad);
                router_1.default.events.off("routeChangeComplete", onPageLoadEnd);
            };
        });
        (0, react_1.useEffect)(() => {
            const syncSignout = (event) => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                if (event.key !== authStorageKey)
                    return;
                (0, token_1.clearAuthToken)(accessTokenKey);
                if (enableApollo)
                    yield apolloClient.cache.reset();
                (0, redirect_1.redirect)({}, (_b = (_a = paths === null || paths === void 0 ? void 0 : paths.beforeAuthPath) !== null && _a !== void 0 ? _a : paths === null || paths === void 0 ? void 0 : paths.signInPath) !== null && _b !== void 0 ? _b : "/");
            });
            window.addEventListener("storage", syncSignout);
            return () => {
                window.removeEventListener("storage", syncSignout);
                window.localStorage.removeItem(authStorageKey);
            };
        }, []);
        return (react_1.default.createElement(AuthIdentityContext_1.AuthIdentityContextProvider, { config: authConfigState, authUser: authUserState, signIn: signIn, signOut: signOut, refetch: fetchUser, setAuthUser: (payload) => setAuthUserState(payload), setAuthToken: setToken, refreshToken: refreshToken, clearAuthToken: clearToken },
            react_1.default.createElement(PageComponent, Object.assign({}, restProps, { pageProps: Object.assign({}, restPageProps) }))));
    };
    if (process.env.NODE_ENV !== "production") {
        const displayName = PageComponent.displayName || PageComponent.name || "Component";
        WithAuth.displayName = `withAuthIdentity(${displayName})`;
    }
    if (ssr || PageComponent.getInitialProps) {
        WithAuth.getInitialProps = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
            var _d;
            const inAppContext = Boolean(ctx.ctx);
            if (refreshAccessToken) {
                const refreshedToken = yield refreshAccessToken(ctx);
                (0, token_1.setAuthTokenToContext)(ctx, refreshedToken, accessTokenKey);
            }
            const authUser = yield checkAuthProfile(ctx);
            let props = {};
            if (PageComponent.getInitialProps) {
                props = yield PageComponent.getInitialProps(ctx);
            }
            else if (inAppContext) {
                props = yield app_1.default.getInitialProps(ctx);
            }
            const { config: authConfigProps } = yield (0, createAuthConfigProps_1.createAuthConfigProps)(ctx.ctx, authUser, options, true);
            return Object.assign(Object.assign({}, props), { pageProps: Object.assign(Object.assign({}, ((_d = props === null || props === void 0 ? void 0 : props.pageProps) !== null && _d !== void 0 ? _d : {})), { authUser, config: authConfigProps !== null && authConfigProps !== void 0 ? authConfigProps : {} }) });
        });
    }
    return WithAuth;
};
exports.withAuthIdentity = withAuthIdentity;
exports.default = exports.withAuthIdentity;
//# sourceMappingURL=index.js.map